import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Site from "../views/Site.vue";
import News from "../views/News.vue";
import Info from "../views/Info.vue";
import Search from "../views/Search.vue";
import Detail from "../views/Detail.vue";
import Collection from "../views/Collection.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("WELCOME_VIEWED")) {
        next({ path: "/news" });
      } else {
        next();
      }
    }
  },
  {
    path: "/site",
    component: Site,
    children: [
      {
        path: "news",
        name: "News",
        alias: "/news",
        component: News
      },
      {
        path: "learn",
        name: "Learn",
        alias: "/learn",
        component: Collection,
        props: { slug: "learn" }
      },
      {
        path: "watch",
        name: "Watch",
        alias: "/watch",
        component: Collection,
        props: { slug: "watch" }
      },
      {
        path: "connect",
        name: "Connect",
        alias: "/connect",
        component: Collection,
        props: { slug: "connect" }
      },
      {
        path: "info",
        name: "Info",
        alias: "/info",
        component: Info
      },
      {
        path: "search",
        name: "Search",
        alias: "/search",
        component: Search
      },
      {
        path: ":slug",
        name: "Collection",
        alias: "/:slug",
        component: Collection,
        props: true
      },
      {
        path: "detail/:itemType/:itemId",
        name: "Detail",
        alias: "/detail/:itemType/:itemId",
        props: true,
        component: Detail
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
